import { render, staticRenderFns } from "./storeSpecialRecord.vue?vue&type=template&id=4b4068a7"
import script from "./storeSpecialRecord.vue?vue&type=script&lang=js"
export * from "./storeSpecialRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports